<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="信贷"
      width="800px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :rules="ruleValidate"
        :model="customerCredit"
        class="form"
        label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="信贷额度">
            <el-input v-model="customerCredit.limitAmount"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="初始付款">
            <el-input v-model="customerCredit.initAmount"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="启用">
            <el-radio-group v-model="customerCredit.isValid">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        disabled: false,
        contentLoading: false,
        dialogVisible: false,
        submitLoading: false,
        customerCredit: {
          pkid: 0,
          customerId: 0,
          limitAmount: 0,
          initAmount: 0,
          isValid: false,
        },
        ruleValidate: {
          customerId: {required: true, message: "未关联客户", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getData(row.customerID);
        });
      },

      // 根据物料id查询价格信息
      getData(id) {
        this.customerCredit.customerId = id;
        this.contentLoading = true;
        this.$http
            .get("basic", `customerCredits/customerId/${id}`)
            .then((resp) => {
              if (resp.success) {
                this.customerCredit = Object.assign(this.customerCredit, resp.data);
              }
              this.contentLoading = false;
            })
            .catch(() => {
              this.contentLoading = false;
            });
      },

      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            // let params = {};
            // for (var i in this.materialPrice) {
            //   if (this.materialPrice[i] !== "****") {
            //     params[i] = +this.materialPrice[i];
            //   }
            // }
            this.submitLoading = true;
            this.$http
                .put("basic", "customerCredits", this.customerCredit)
                .then((res) => {
                  this.submitLoading = false;
                  if (res.success) {
                    this.$emit("save-success");
                    this.$message.success("信贷维护成功");
                  }
                  this.dialogVisible = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>
